module.exports = require("child_process");


/*****************
 ** WEBPACK FOOTER
 ** external "child_process"
 ** module id = 382
 ** module chunks = 0
 **/